import React from 'react';

import SvgImage from '../svg-image';
import style from './index.css';

const CalendarIcon: React.FC = () => {
    const dayOfMonth = new Date().getDate();

    return (
        <div className={style.container}>
            <SvgImage imageName="ios" style={{ width: 64, height: 64, position: 'absolute' }} />
            <span className={style.content}>{dayOfMonth}</span>
        </div>
    );
};

export default CalendarIcon;
